import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CargadorPcPage, TabsPage } from '@pages';
import { ASSETS } from '@env';
import { DesafioPersonalProvider } from '@providers/desafio-personal/desafio-personal';

@IonicPage()
@Component({
  selector: 'page-resultado-bot',
  templateUrl: 'resultado-bot.html',
})
export class ResultadoBotPage {

  AVATAR_PLAYER = ASSETS.AVATAR_PLAYER;
  estatus: {
    esGanador: boolean;
    calculando: boolean;
    scoreRonda: number;
    incorrectasBot: number;
    correctasBot: number;
    tiempo: number;
  };
  bot: any;
  jugador: any;
  resultado: any;
  equipo: any;
  estadisticas: Array<any>;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public desafioPersonalProvider: DesafioPersonalProvider,
  ) {
    this.estatus = {
      esGanador: false,
      calculando: true,
      scoreRonda: 0,
      incorrectasBot: 0,
      correctasBot: 0,
      tiempo: 0,
    }

    this.bot = this.navParams.get('bot');
    this.jugador = this.navParams.get('jugador');
    this.equipo = this.navParams.get('equipo');
    this.resultado = this.navParams.get('resultado');

    this.resultado.scoreRonda = this.resultado.estadisticas.filter( p => p.esCorrecta ).reduce( (a, b) => a + b.puntos, 0)
    this.resultado.tiempo = this.resultado.estadisticas.filter( p => p.esCorrecta ).reduce( (a, b) => a + b.tiempo, 0)

    this.estadisticas = this.resultado.estadisticas.map( e => ({
      usuario: e, 
      bot: {
        pregunta: e.pregunta,
        tiempo: 0,
        puntos: 0,
        esCorrecta: false
      }
    }));
  }

  ionViewDidLoad() {    
    this.calculaResultadoRobot();

    setTimeout( () => this.muestraResultados(), 2000);
  }
  
  muestraResultados(index = 0) {
    if(this.estadisticas[index]) {
      this.estadisticas[index].bot.muestraResultado = true;

      this.estatus.calculando =  this.estadisticas[index + 1] ? true: false;
      
      setTimeout( () => this.muestraResultados(index+1), 2000);
      
    }
  }

  calculaResultadoRobot() {
    const totalPreguntas = this.resultado.totalCorrectas + this.resultado.totalIncorrectas;
    const totalCorrectas = this.resultado.totalCorrectas;
    
    let eficacia = Math.round((totalCorrectas * 100) / totalPreguntas);

    if(!eficacia) {
      eficacia = this.bot.tipoBot == 'YIBIX-1' ? 75: 50;
    }

    if(this.bot.tipoBot == 'YIBIX-1') {
      let diff = 100 - eficacia;
      eficacia = eficacia + (diff / 2 );
    }

    eficacia = Math.round(eficacia);

    let scoreRonda = 0;
    let tiempo = 0;

    this.estadisticas = this.resultado.estadisticas.map( e => {
      const rand = this.getRandomInt(1,100);
      let puntosPregunta = 0;
      let tiempoPregunta = 0;

      if(rand <= eficacia) {

        puntosPregunta = this.calculaPuntosPregunta();
        scoreRonda += puntosPregunta;

        tiempoPregunta = this.calculaTiempoPregunta(puntosPregunta);
        tiempo += tiempoPregunta;
      }
 
      return {
        usuario: e, 
        bot: {
          pregunta: e.pregunta,
          tiempo: rand <= eficacia ? tiempoPregunta: 0,
          puntos: rand <= eficacia ? puntosPregunta: 0,
          esCorrecta: rand <= eficacia ? true: false,
          muestraResultado: false,
        }
      }
    });

    this.estatus.tiempo = tiempo;
    this.estatus.scoreRonda = scoreRonda;
    this.estatus.esGanador = this.resultado.scoreRonda >= this.estatus.scoreRonda ? true: false;
  }

  calculaPuntosPregunta() {
    const rand = this.getRandomInt(1,100);
    
    if(this.bot.tipoBot == 'YIBIX-1') {
      return this.calculaPuntosPreguntaHard(rand);
    } else {
      return this.calculaPuntosPreguntaEasy(rand);
    }
  }

  calculaPuntosPreguntaHard(rand: number) {
    if(rand <= 30 ) return 10;
    
    if(rand > 30 && rand <= 55) return 12;
    
    if(rand > 55 && rand <= 75) return 14;
    
    if(rand > 75 && rand <= 90) return 16;
    
    if(rand > 90 ) return 18;
  }
 
  calculaPuntosPreguntaEasy(rand: number) {
    if(rand <= 50 ) return 10;
    
    if(rand > 50 && rand <= 70) return 12;
    
    if(rand > 70 && rand <= 85) return 14;
    
    if(rand > 85 && rand <= 95) return 16;
    
    if(rand > 95 ) return 18;
  }

  calculaTiempoPregunta(puntos: number) {    
    if(puntos == 18 ) return this.getRandomInt(1,2);
    
    if(puntos == 16 ) return this.getRandomInt(2,4);
    
    if(puntos == 14 ) return this.getRandomInt(4,6);
    
    if(puntos == 12 ) return this.getRandomInt(6,8);
    
    if(puntos == 10 ) return this.getRandomInt(8, 15);
    
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  round(num: number) {
    return Math.round((num + Number.EPSILON) * 100) / 100
  }

  async continuar() {
    // Guardar todas las rondas
    if(this.bot.rondaActual == this.bot.totalRondas) {

      try {
        // this.resultado.area = this.equipo.area._id;

        const params = {
          area: this.equipo.area._id,
          jugador: this.jugador._id,
          estadisticas: this.bot.estadisticas
        }

        await this.desafioPersonalProvider.saveStatsBot(params);
      } catch (error) { } finally {
        this.navCtrl.setRoot(TabsPage, {
          active: 0
        });
      }

    } else {

      this.bot.rondaActual++;
      this.navCtrl.setRoot(CargadorPcPage, {
        jugador: this.jugador,
        equipo: this.equipo,
        bot: this.bot
      });

    }    
  }

}



// WEBPACK FOOTER //
// ./src/pages/personal-challenge/resultado-bot/resultado-bot.ts